<template>
  <z-form-group class="row">
    <div class="col-4 text-right">{{ label }}</div>
    <z-form-input class="col-8">
      <i-button @click="$emit('on-browse')">
        {{ button_label || $tc('pbx.worksheet.action.menu.input.select_file', 1) }}
      </i-button>
    </z-form-input>
  </z-form-group>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },

      button_label: {
        type: String,
        default: null
      }
    }
  };
</script>
